// extracted by mini-css-extract-plugin
export default {"p":"e7663d0a2d _7b0b407f3e _94ccbe8a09","clr":"c2c01515eb","dls":"_8f06076079"};